import { Typography } from '@mui/material'

export const AgronomicDataCSVEditor = () => (
  <Typography>This trait cannot be edited here.</Typography>
)
